<template>
  <transition name="fade">
    <div v-if="visible" class="toast" :class="type">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      type: "info",
      timeout: null,
    };
  },
  methods: {
    showToast(message, type = "info", duration = 3000) {
      this.message = message;
      this.type = type;
      this.visible = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.visible = false;
      }, duration);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.toast {
  position: fixed;
  left: 50%;
  top: 10px;
  /* bottom: 20px; */
  transform: translateX(-50%);
  padding: 10px 20px;
  color: #fff;
  border-radius: 5px;
  font-size: 16px;
  z-index: 1000;
}
.info {
  background-color: #3498db;
}
.error {
  background-color: #e74c3c;
}
.success {
  background-color: #2ecc71;
}
.warning {
  background-color: #f1c40f;
}
</style>
